import { render, staticRenderFns } from "./ItemProfileField.vue?vue&type=template&id=2691e4cf&scoped=true"
import script from "./ItemProfileField.vue?vue&type=script&lang=js"
export * from "./ItemProfileField.vue?vue&type=script&lang=js"
import style0 from "./ItemProfileField.vue?vue&type=style&index=0&id=2691e4cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2691e4cf",
  null
  
)

export default component.exports